import { useState, useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/reduxHooks";
import { setRefresher } from "../../../../../store/slices/productSlice";

import {
  checkAndCreateSessionIdFromCookie,
  getTempCart,
  saveSelectedColorsToCookie,
} from "../../../../../../utils/utils";
import Cookies from "js-cookie";

checkAndCreateSessionIdFromCookie();

const ProductItem = ({
  productData,
  id,
  handleDeleteProduct,
  position,
}: any) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const productImages = useAppSelector((state) => state.product.product_images);
  const productOption: any = useAppSelector(
    (state: any) => state.product.product_colors.catalogproductvariants
  );
  const productDataFromSlice = useAppSelector(
    (state) => state.product.product_basic_details
  );
  const refresher = useAppSelector((state) => state.product.refresher);

  const [selectedColors, setSelectedColors] = useState<any>(null);
  const dispatch = useAppDispatch();

  const product_details = useAppSelector(
    (state) => state.product.product_details
  );

  useEffect(() => {
    const cartData = getTempCart();
    if (cartData) {
      const { sessionId, selectedColors } = JSON.parse(cartData);
      // Optionally check if sessionId matches User_Session_ID
      if ((!selectedColors || selectedColors.length === 0) && productOption) {
        debugger;
        const colors = groupColorsBasedOnOption1(productOption);
        if (colors.length > 0) {
          // setSelectedColors(colors[0].id);
          debugger;
          setNewColor(colors[0]);
        }

        // setSelectedColors(colors[0].id);
      }

      setSelectedColors(selectedColors);
    } else {
      if (productOption) {
        const colors = groupColorsBasedOnOption1(productOption);
        if (colors.length > 0) {
          // setSelectedColors(colors[0].id);
          debugger;
          setNewColor(colors[0]);
        }
      }
    }
  }, [refresher, productOption]);

  const handleChangeColor = (variant_id: any) => {
    //setActiveColor(variant_id);
    //dispatch(setNewProductColor(variant_id));
  };

  const groupColorsBasedOnOption1 = (colors: any) => {
    const groupedColors: any = {};
    colors.forEach((color: any) => {
      if (!groupedColors[color.option1]) {
        groupedColors[color.option1] = [];
      }
      groupedColors[color.option1].push(color);
    });

    const resultArray = [];

    for (const color in groupedColors) {
      if (groupedColors.hasOwnProperty(color)) {
        // Pick the first item from each group
        const firstItem = groupedColors[color][0];
        resultArray.push(firstItem);
      }
    }

    return resultArray;
  };

  const getImageUrlByVariantId = (variantId: number) => {
    const matchedItem = productImages.find(
      (item: any) => item.image_id === variantId
    );
    return matchedItem ? matchedItem.src : null;
  };

  const setNewColor = (color: any) => {
    debugger;
    console.log("Attempting to add new color:", color);

    // Check if the color ID already exists in the selected colors
    const isColorAlreadySelected = selectedColors?.some(
      (selectedColor: any) => selectedColor === color.id
    );

    if (isColorAlreadySelected) {
      console.log("Color already selected, skipping.");
      setShowColorPicker(false);
      return; // Stop further execution
    }

    console.log("New color added:", color);
    const uniqueId: any = checkAndCreateSessionIdFromCookie();
    saveSelectedColorsToCookie(
      uniqueId,
      [...(selectedColors || []), color.id],
      product_details.CustomizedProductID
    );
    //setSelectedColors((prevColors: any) => [...(prevColors || []), color]);

    setShowColorPicker(false);
    dispatch(setRefresher(!refresher));
  };
  const deleteNewColor = (color: any) => {
    const newColors = selectedColors.filter(
      (selectedColor: any) => selectedColor !== color.id
    );

    console.log("New color list:", newColors);
    setSelectedColors(newColors);
    const uniqueId: any = checkAndCreateSessionIdFromCookie();
    saveSelectedColorsToCookie(
      uniqueId,

      newColors,
      product_details.CustomizedProductID
    );
    dispatch(setRefresher(!refresher));
  };

  return (
    <div className="relative shadow-card bg-[#f6f6f6] border border-solid border-[#e3e7eb] rounded-md p-3 my-4">
      <div className="font-bold text-sm truncate hover:text-clip hover:whitespace-normal">
        {productDataFromSlice && productDataFromSlice.title}
      </div>

      <div className="flex justify-between items-center mt-5 text-grey tracking-wide">
        <div className="flex flex-wrap gap-1 w-[75%] text-xs">
          {selectedColors
            ? groupColorsBasedOnOption1(productOption).map((color: any) =>
                selectedColors && selectedColors.includes(color.id) ? (
                  <div
                    key={color.variant_id}
                    onClick={() => handleChangeColor(color.variant_id)}
                  >
                    <div className="flex relative">
                      <div className="w-[40px] max-h-fit text-center mb-5 ml-3">
                        <button
                          onClick={() => deleteNewColor(color)}
                          className="absolute top-[-2px] right-[-5px]"
                        >
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 12 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.3955 11.1593C11.3955 11.6331 11.228 12.0375 10.8929 12.3726C10.5578 12.7077 10.1591 12.8752 9.69695 12.8752C9.16543 12.8752 8.74367 12.6903 8.4317 12.3206L5.84919 9.23546L3.26669 12.3206C2.95471 12.6903 2.53296 12.8752 2.00144 12.8752C1.53924 12.8752 1.1406 12.7077 0.805513 12.3726C0.470423 12.0375 0.302878 11.6331 0.302878 11.1593C0.302878 10.7318 0.441536 10.3621 0.718852 10.0501L3.63067 6.79161L0.926838 3.81047C0.649523 3.49849 0.510865 3.11718 0.510865 2.66654C0.510865 2.19279 0.67841 1.79415 1.0135 1.47062C1.36014 1.13553 1.76456 0.967983 2.22676 0.967983C2.76983 0.967983 3.21469 1.18752 3.56134 1.62661L5.84919 4.43443L8.13705 1.62661C8.48369 1.18752 8.92855 0.967983 9.47163 0.967983C9.93382 0.967983 10.3325 1.13553 10.6676 1.47062C11.0142 1.79415 11.1875 2.19279 11.1875 2.66654C11.1875 3.12873 11.1009 3.44649 10.9275 3.61981L8.06772 6.79161L10.9795 10.0501C11.2568 10.3621 11.3955 10.7318 11.3955 11.1593Z"
                              fill="#CCCFD6"
                            />
                          </svg>
                        </button>
                        <img
                          src={getImageUrlByVariantId(color.image_id)}
                          alt=""
                          className="w-full h-auto"
                        />
                        <span>{color.option1}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )
              )
            : ""}
        </div>
        {/* <div className="flex justify-center w-[25%] relative">
          <button
            onClick={() => setShowColorPicker((prev) => !prev)}
            className="text-xs text-center"
          >
            <svg
              className="mx-auto"
              width="43"
              height="43"
              viewBox="0 0 43 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <rect width="43" height="43" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_43878_33141"
                    transform="scale(0.02)"
                  />
                </pattern>
                <image
                  id="image0_43878_33141"
                  width="50"
                  height="50"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
            Add Color
          </button>
          <ProductColorPicker
            position={position}
            title="Add another colors"
            colors={groupColorsBasedOnOption1(productOption)}
            show={showColorPicker}
            setShowColorPicker={setShowColorPicker}
            setNewColor={setNewColor}
          />
        </div> */}
      </div>
    </div>
  );
};
export default ProductItem;
